module.exports = __webpack_public_path__ + "img/type-underline.b8ef1b92.svg";